import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { fetchData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import IconButton from '@mui/material/IconButton';
import EditIcon from '@mui/icons-material/Edit';
import AddIcon from '@mui/icons-material/Add';
import CopyrightIcon from '@mui/icons-material/Copyright';
import '../shared.css';

function BranchIndex() {
  const {
    isAuthenticated, companyId, branchId, permissions,
    isSuperAdmin, superCompanyId, logout, token,
  } = useAuth();

  const [data, setData] = useState([]);

  useEffect(() => {
    if (isAuthenticated && tokenIsExpired(token)) { logout(); return; }
  }, [isAuthenticated, companyId, branchId, token, logout]);

  const hasEditMasterPermission = permissions.includes('Edit Master');

  useEffect(() => {
    const endpoint = isSuperAdmin
      ? `/${companyId}`
      : `/BranchData/${branchId}`;

    fetchData('BranchApi', endpoint, token)
      .then(res => { if (res.responseCode === '1111') setData(res.response_data); })
      .catch(err => console.error('Error fetching Branch Details:', err));
  }, [isSuperAdmin, companyId, branchId, token]);

  return (
    <div className="pg-container">

      {/* Header */}
      <div className="pg-header">
        <h5 className="pg-title">Branch</h5>
        <div className="pg-header-actions">
          {isSuperAdmin && companyId == superCompanyId && (
            <Link to="/branchCreate" className="pg-btn pg-btn-primary">
              <AddIcon /> Create New
            </Link>
          )}
        </div>
      </div>

      {/* Table */}
      <div className="pg-table-wrap">
        <table className="pg-table">
          <thead>
            <tr>
              <th>#</th>
              <th>Name</th>
              <th>Branch Code</th>
              <th>Contact Number</th>
              <th>Email</th>
              <th>GST Number</th>
              <th>CIN Number</th>
              <th style={{ textAlign: 'right' }}>Actions</th>
            </tr>
          </thead>
          <tbody>
            {data.length === 0 ? (
              <tr>
                <td colSpan={8} style={{ textAlign: 'center', color: '#94a3b8', padding: '20px' }}>
                  No branches found
                </td>
              </tr>
            ) : (
              data.map((item, index) => (
                <tr key={item.Id}>
                  <td>{index + 1}</td>
                  <td>{item.Name}</td>
                  <td>{item.BranchCode}</td>
                  <td>{item.ContactNumber1}</td>
                  <td>{item.Email}</td>
                  <td>{item.GSTNumber}</td>
                  <td>{item.CINNumber}</td>
                  <td className="actions-cell">
                    {hasEditMasterPermission && (
                      <Link to={`/branchEdit/${item.Id}`}>
                        <IconButton size="small" color="primary">
                          <EditIcon style={{ fontSize: 17 }} />
                        </IconButton>
                      </Link>
                    )}
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      <div className="pg-watermark">
        <CopyrightIcon style={{ fontSize: 12 }} />
        <b>EFFTABS SOLUTIONS LLP</b>
      </div>
    </div>
  );
}

export default BranchIndex;
